import searchFocus from "./searchFocus";

export default function searchOpener() {
  $('.search-opener').on('click', function () {
    if ($('.search-holder').hasClass('active')) {
      $('.search-holder').removeClass('active');
    } else {
      $('.search-holder').addClass('active');
      setTimeout(function () {
        searchFocus();
      }, 100);
    }
  });
}